<mat-dialog-content>
  <div class="confirm-dialog text-center">
    <div class="staff-avatar mb-3">
      <div class="avatar-circle-lg" [ngClass]="mode === 'clockIn' ? 'bg-success' : 'bg-danger'">
        {{staffName?.charAt(0)?.toUpperCase()}}
      </div>
    </div>

    <h4 class="fw-bold mb-1">{{staffName}}</h4>
    <p class="text-muted mb-3">{{staffNo}}</p>

    <div class="action-label mb-3">
      <span class="badge" [ngClass]="mode === 'clockIn' ? 'badge-clock-in' : 'badge-clock-out'">
        <i class="fa me-1" [ngClass]="mode === 'clockIn' ? 'fa-sign-in-alt' : 'fa-sign-out-alt'"></i>
        {{mode === 'clockIn' ? 'CLOCK IN' : 'CLOCK OUT'}}
      </span>
    </div>

    <div class="time-display mb-3">
      <i class="fa fa-clock me-1"></i>
      <span class="fs-5 fw-bold">{{currentTime | date: 'hh:mm:ss a'}}</span>
    </div>

    <div *ngIf="mode === 'clockOut'" class="session-info mb-2">
      <div class="text-muted small">Clocked in at: {{clockIn | date: 'hh:mm a'}}</div>
      <div class="text-muted small">Duration: {{formatDuration(durationMinutes)}}</div>
    </div>

    <div *ngIf="nfcEnabled" class="nfc-hint mt-2">
      <div class="d-flex align-items-center justify-content-center text-muted small">
        <mat-icon class="nfc-pulse-icon me-1">nfc</mat-icon>
        <span>NFC Ready — tap card on reader to {{mode === 'clockIn' ? 'clock in' : 'clock out'}}</span>
      </div>
    </div>
  </div>
</mat-dialog-content>

<mat-dialog-actions>
  <div class="d-flex flex-column align-items-center w-100 px-3 pb-3">
    <button
      class="btn text-white w-100 py-3"
      [ngClass]="mode === 'clockIn' ? 'btn-success' : 'btn-danger'"
      (click)="confirm()">
      <i class="fa me-2" [ngClass]="mode === 'clockIn' ? 'fa-sign-in-alt' : 'fa-sign-out-alt'"></i>
      <span *ngIf="!nfcEnabled">{{mode === 'clockIn' ? 'Confirm Clock In' : 'Confirm Clock Out'}}</span>
      <span *ngIf="nfcEnabled">{{mode === 'clockIn' ? 'Confirm Clock In or Scan NFC' : 'Confirm Clock Out or Scan NFC'}}</span>
    </button>
    <button class="btn btn-light w-100 py-2 mt-2" (click)="cancel()">Cancel</button>
  </div>
</mat-dialog-actions>
